import { onAttach, onDetach } from '../attach';
import { UIView, UIViewSpec } from '../view';

export interface UIInkBarOptions {
    border?: number;
}

export class UIInkBar extends UIView {
    private _left?: number;
    private _elem?: HTMLElement;
    private _handler?: any;
    private _border: number;

    constructor(options: UIInkBarOptions = {}) {
        super('div', 'ui-inkbar');

        this._border = options.border || 0;

        onAttach(this, () => {
            this._doUpdate();
            window.addEventListener('resize', this._handler = () => { this._doUpdate() });
        });

        onDetach(this, () => {
            if(this._handler) {
                window.removeEventListener('resize', this._handler);
                this._handler = undefined;
            }
        });
    }

    private _doUpdate(animate?: boolean) {
        const elem = this._elem;
        if(!elem) return;
        const parent = this.root.parentElement;
        if(!parent) return;

        const border = this._border;
        const parent_bounding = parent.getBoundingClientRect();
        const elem_bounding = elem.getBoundingClientRect();

        const left = elem_bounding.left - parent_bounding.left - border;
        const right = parent_bounding.right - elem_bounding.right - border;

        if(this._left != undefined && animate) {
            if(left > this._left) {
                this.classList.add('f-to-right');
                this.classList.remove('f-to-left');
            } else {
                this.classList.add('f-to-left');
                this.classList.remove('f-to-right');
            }
        } else {
            this.classList.remove('f-to-right', 'f-to-left');
        }

        this._left = left;

        this.root.style.left = left + 'px';
        this.root.style.right = right + 'px';
    }

    update(where: UIViewSpec) {
        this._elem = where.ui_elem;
        this._doUpdate(true);
    }
}